{{#if filtersEnabled}}
    <button type="button" class="btn btn-sm btn-tertiary js-clear-filters" aria-label="{{locale "clear"}}">{{locale "clear"}}</button>
{{/if}}